import LibraryDocumentsConfig from './LibraryDocumentsConfig';

export default LibraryDocumentsConfig;
